import Gallery from './gallery';

export const Galleries = () => {
  const galleries = document.querySelectorAll('.c-gallery');

  if (!galleries) return;

  galleries.forEach((gallery) => {
    const mainImage = gallery.querySelector('.js-gallery-main');
    const thumbnails = gallery.querySelectorAll('.js-gallery-thumbnail');
    const thumbnailsWrapper = gallery.querySelector('.js-gallery-wrapper');
    const captionArea = gallery.querySelector('.js-gallery-text') ? gallery.querySelector('.js-gallery-text') : '';
    const arrows = gallery.querySelectorAll('.js-gallery-arrow') ? gallery.querySelectorAll('.js-gallery-arrow') : '';
    const zoom = document.querySelector('.js-zoom-on-hover');

    if (!mainImage || !thumbnails || !thumbnailsWrapper) return;

    new Gallery(mainImage, thumbnails, thumbnailsWrapper, captionArea, arrows, zoom);
  });
}